import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// TODO: Look into seeing if we need to pull survey actions from a PL specific frontlib
import { surveyActions } from '@figure/frontlib-onboarding-redux';

const useLeaveSurvey = (uuid) => {
  // TODO: See if we can `useParams` instead of passing UUID
  const dispatch = useDispatch();
  const leaveSurvey = useSelector(({ leaveSurveyReducer }) => leaveSurveyReducer);
  const { leaveReasons } = useSelector(({ surveyTypeReducer }) => surveyTypeReducer);

  useEffect(() => {
    dispatch(surveyActions.getLeaveSurveyReasons());
  }, [dispatch]);

  return {
    leaveReasons,
    leaveSurvey,
    handleSubmit: async (data) => await dispatch(surveyActions.saveLeaveSurvey(uuid, data)),
  };
};

export default useLeaveSurvey;
